import { createSelector } from 'reselect';

import { EServiceType, IBaseService } from '~/src/features/managementAgreement/SuspendServices/store/types';

export const getServicesByType = createSelector(
    [
        (services: IBaseService[]) => services,
        (_: IBaseService[], type: EServiceType) => type,
    ],
    (services, type) => services.filter(el => el.type === type),
);
